// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7bff906a","prominentTile":"_75f5a7d5","sideTile":"_a412c4b6"};